var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.showFileList") } },
    [
      _c("el-switch", {
        model: {
          value: _vm.optionModel.showFileList,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "showFileList", $$v)
          },
          expression: "optionModel.showFileList",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }